import { Zoom } from 'react-toastify';
import { Check, X } from 'lucide-react';

export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
export const COGNITO_URL = process.env.REACT_APP_COGNITO_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const WSS_URL = process.env.REACT_APP_WSS_URL;

export const TOAST_STYLE_SUCCESS = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  type: 'success',
  icon: <Check />,
  transition: Zoom,
  style: {
    background: '#fff', // Black background for a bold look
    color: '#000', // White text for strong contrast
    boxShadow: '0 4px 8px rgba(255, 255, 255, 0.2)', // Soft white shadow for depth
    border: '1px solid #000', // White border for a clean, minimalistic look
    borderRadius: '12px', // Rounded corners for a modern feel
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', // Elegant font choice
    fontSize: '16px', // Easy-to-read text size
    fontWeight: 'normal' // Keeping it stylish and readable
  }
};

export const TOAST_STYLE_ERROR = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  type: 'error',
  icon: <X />,
  transition: Zoom,
  style: {
    background: '#fff', // Black background for a bold look
    color: '#000', // White text for strong contrast
    boxShadow: '0 4px 8px rgba(255, 255, 255, 0.2)', // Soft white shadow for depth
    border: '1px solid #000', // White border for a clean, minimalistic look
    borderRadius: '12px', // Rounded corners for a modern feel
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', // Elegant font choice
    fontSize: '16px', // Easy-to-read text size
    fontWeight: 'normal' // Keeping it stylish and readable
  }
};

export const SUBSCRIPTION_EXPIRED_CODE = 'SUBSCRIPTION_EXPIRED';
export const SUBSCRIPTION_CANCELED_CODE = 'SUBSCRIPTION_CANCELED';
